import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router';
// styles
import styles from './styles.module.scss';
// types
import { IAccountRegistrationEnum } from '@/models/account/types';
// images
import Lock from '@/components/ui/new-icons/Lock';
import {
  ForwardArrow,
} from '@/components/landing-page-templates/ConfigLandingPage/LandingPageIcons';
import {
  ILandingPageButtonStyle,
} from '@/components/landing-page-templates/ConfigLandingPage/types';

const LogoutPromptForNotCheckedinUsers = ({
  currentUser,
  landingPageObject,
  isSpeakerPage,
  redirectToAttendeePageForDuda,
  isEmbedView,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { eventId } = useParams<{ eventId: string }>();

  const {
    formBgColour = '#081529',
    formFontColour = '#FFFFFF',
  } = landingPageObject;

  const buttonBgColor: string =
    formBgColour === '#000000' ? '#353535' : formBgColour;

  const buttonStyle: ILandingPageButtonStyle = {
    backgroundColor: buttonBgColor,
    color: formFontColour,
  };

  const logoutHandler = () => {
    // If user is logged in, log them out (This case would happen if a user was already logged in
    //  from another session and goes to this landing page but does not have access to the event.)
    if (currentUser && currentUser.accountId) {
      // Logout this account since it does not have access to the event
      dispatch({
        type: 'account/logoutNoRedirect',
      });
    }

    // Set the registration step back to login method
    dispatch({
      type: 'account/setRegistrationStep',
      payload: { registrationStep: IAccountRegistrationEnum.LOGIN_METHOD },
    });
  };

  const redirectToAttendeePage = () => {
    if (isEmbedView && redirectToAttendeePageForDuda) {
      redirectToAttendeePageForDuda();
    } else {
      history.push(`/p/a/event/${eventId}`);
      window.location.reload();
    }
  };

  return (
    <>
      <div className={styles.outerSectionContainer}>
        <div className={styles.innerSectionContainer}>
          <Lock color={'black'}/>
        </div>
      </div>
      {currentUser?.accountId ? 
      <div className={styles.mainHeading}>Hello {currentUser?.firstName ? currentUser?.firstName : 'Attendee'}!</div>
      :
      <div className={styles.mainHeading}>Hello!</div>
      }
      
      {currentUser?.accountId && !isSpeakerPage && <div className={styles.heading}>
        <p>You are already signed in for another event.</p>
        <p>You must sign out first before you can access this event.</p>
      </div>}
      {currentUser?.accountId && isSpeakerPage && <div className={styles.heading}>
        <p>You are signed in.</p>
        <p>You don't have access to this event.</p>
      </div>}
      {!currentUser?.accountId && <div className={styles.heading}>
        <p>You don't have access to this event.</p>
        <p>Are you an Attendee? <span className={styles.attendeeLpRoute} onClick={() => redirectToAttendeePage()}>click here</span></p>
        </div>}

      {currentUser?.accountId && <div className={styles.button}>
        <button
          type="submit"
          onClick={logoutHandler}
          style={buttonStyle}
          className={styles.submitButton}
        >
          {/* Forward Arrow SVG */}
          <ForwardArrow color={buttonStyle.color}/>
          <p className={styles.buttonText}>Sign Out</p>
        </button>
      </div>}
    </>
  );
};
export default LogoutPromptForNotCheckedinUsers;
